export const reservationsPlugin = {
	id: 'reservations',
	nameKey: 'linker.plugins.reservations.name',
	descriptionKey: 'linker.plugins.reservations.description',
	icon: 'calendar',
	iconFile: 'assets/v2/image/icons/calendar.svg',
	settingsPath: '/v2/linker/reservation-settings',
	features: [
		'linker.plugins.reservations.feature-1',
		'linker.plugins.reservations.feature-2',
		'linker.plugins.reservations.feature-3',
	],
	routes: [
		{
			path: 'reservations',
			component: () => import('../../pages/reservations/index.vue'),
			titleKey: 'linker.reservations-list',
		},
		{
			path: 'reservation-settings',
			component: () => import('../../pages/reservation-settings/index.vue'),
			titleKey: 'linker.reservation-settings.title',
		},
	],
	sidebar: [
		{
			labelKey: 'linker.reservations-list',
			path: '/v2/linker/reservations',
		},
	],
};
